import {detailServicesPath} from "../../Constants";
import axios from "axios";

const detailControllerRestUrl = detailServicesPath + '/organizations/compositions/variables-module'

export default class CompositionsVariablesService {
    static async save(moduleId, data) {
        return await axios.post(`${detailControllerRestUrl}?moduleId=${moduleId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(variableId) {
        return await axios.delete(`${detailControllerRestUrl}/${variableId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async edit(variableId, data) {
        return await axios.put(`${detailControllerRestUrl}/${variableId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async prevAll(detailId, data) {
        return await axios.post(`${detailControllerRestUrl}/preview-all?detailId=${detailId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}